export const IconOrder = () => {
    return (
        <>
            <svg className="mr-0.6" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_569_9313" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="18">
                    <rect x="0.5" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_569_9313)">
                    <path d="M4.25 16.5029C3.8375 16.5029 3.48438 16.3561 3.19063 16.0623C2.89688 15.7686 2.75 15.4154 2.75 15.0029V6.00293C2.75 5.59043 2.89688 5.2373 3.19063 4.94355C3.48438 4.6498 3.8375 4.50293 4.25 4.50293H5.75C5.75 3.46543 6.11563 2.58105 6.84688 1.8498C7.57812 1.11855 8.4625 0.75293 9.5 0.75293C10.5375 0.75293 11.4219 1.11855 12.1531 1.8498C12.8844 2.58105 13.25 3.46543 13.25 4.50293H14.75C15.1625 4.50293 15.5156 4.6498 15.8094 4.94355C16.1031 5.2373 16.25 5.59043 16.25 6.00293V15.0029C16.25 15.4154 16.1031 15.7686 15.8094 16.0623C15.5156 16.3561 15.1625 16.5029 14.75 16.5029H4.25ZM4.25 15.0029H14.75V6.00293H4.25V15.0029ZM9.5 10.5029C10.5375 10.5029 11.4219 10.1373 12.1531 9.40606C12.8844 8.67481 13.25 7.79043 13.25 6.75293H11.75C11.75 7.37793 11.5312 7.90918 11.0938 8.34668C10.6562 8.78418 10.125 9.00293 9.5 9.00293C8.875 9.00293 8.34375 8.78418 7.90625 8.34668C7.46875 7.90918 7.25 7.37793 7.25 6.75293H5.75C5.75 7.79043 6.11563 8.67481 6.84688 9.40606C7.57812 10.1373 8.4625 10.5029 9.5 10.5029ZM7.25 4.50293H11.75C11.75 3.87793 11.5312 3.34668 11.0938 2.90918C10.6562 2.47168 10.125 2.25293 9.5 2.25293C8.875 2.25293 8.34375 2.47168 7.90625 2.90918C7.46875 3.34668 7.25 3.87793 7.25 4.50293Z" fill="#FAF3E6" />
                </g>
            </svg>
        </>
    )
}
export const IconDownload = () => {
    return (
        <>
            <svg className="mr-0.6" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_569_9223" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                    <rect x="0.25" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_569_9223)">
                    <path d="M6.24902 19.9961C5.69902 19.9961 5.22819 19.8003 4.83652 19.4086C4.44486 19.0169 4.24902 18.5461 4.24902 17.9961V14.9961H6.24902V17.9961H18.249V14.9961H20.249V17.9961C20.249 18.5461 20.0532 19.0169 19.6615 19.4086C19.2699 19.8003 18.799 19.9961 18.249 19.9961H6.24902ZM12.249 15.9961L7.24902 10.9961L8.64902 9.54609L11.249 12.1461V3.99609H13.249V12.1461L15.849 9.54609L17.249 10.9961L12.249 15.9961Z" fill="#9FB2B6" />
                </g>
            </svg>
        </>
    )
}
export const IconClose = () => {
    return (
        <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-4"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>


        </>
    )
}
export const IconNewClose = () => {
    return (
        <>
            <svg width="1.8vh" height="1.8vh" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_792_75" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="19">
                    <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_792_75)">
                    <path d="M4.80098 14.751L3.75098 13.701L7.95098 9.50098L3.75098 5.30098L4.80098 4.25098L9.00098 8.45098L13.201 4.25098L14.251 5.30098L10.051 9.50098L14.251 13.701L13.201 14.751L9.00098 10.551L4.80098 14.751Z" fill="#4F504C" />
                </g>
            </svg>


        </>
    )
}